import { Injectable } from "@angular/core";
import { NavbarNavItem } from "../models/navbar-nav-item";

@Injectable({
  providedIn: "root",
})
export class NavbarNavTeacherProvider {
  getRightSideItems(): Array<NavbarNavItem> {
    return [
      {
        label: "GLOBAL.NAVBAR.NAV.GROUPS",
        icon: "group-outline",
        iconSet: "typcn",
        route: "/teacher/groups",
      },
      {
        label: "GLOBAL.NAVBAR.NAV.COURSES",
        icon: "mortar-board",
        iconSet: "typcn",
        route: "/teacher/courses",
      },
      {
        label: "GLOBAL.NAVBAR.NAV.RANKING",
        icon: "trophy",
        iconSet: "uil",
        route: "/teacher/ranking",
      },
    ];
  }

  getLeftSideItems(): Array<NavbarNavItem> {
    return [
      {
        label: "GLOBAL.NAVBAR.NAV.DASHBOARD",
        icon: "home-outline",
        iconSet: "typcn",
        route: "/teacher/dashboard",
      },
    ];
  }
}
